import styled, { css } from 'styled-components';

export const ControlContainer = styled.div`
  display: flex;
  margin-left: auto;
  padding: 0 10px;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 10px;
  border: 2px solid;
  column-gap: 5px;
  height: 40px;
`;

export const Control = styled.button<{ active?: boolean }>`
  ${({ active = true }) => css`
    display: flex;
    padding-block: 0;
    padding-inline: 0;
    border-radius: 6px;
    padding: 4px;
    border: none;
    background: white;
    margin: 0;
    cursor: ${active ? 'pointer' : 'default'};
    &:hover {
      background: ${active ? '#eeeeee' : 'none'};
    }
    &:active {
      background: ${active ? '#d9d9d9' : 'none'};
    }
  `}
`;
